import { render, staticRenderFns } from "./CenterModel.vue?vue&type=template&id=b56c9e76&scoped=true&"
import script from "./CenterModel.vue?vue&type=script&lang=js&"
export * from "./CenterModel.vue?vue&type=script&lang=js&"
import style0 from "./CenterModel.vue?vue&type=style&index=0&id=b56c9e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c9e76",
  null
  
)

component.options.__file = "CenterModel.vue"
export default component.exports